import React, { Dispatch, SetStateAction } from "react"
import dayjs from "dayjs"
import { showEditSidebar } from "lib/store/services/editSidebar/slice"
import { useQuery } from "@apollo/client"
import { useAppDispatch } from "lib/store"

import { GET_EXTERNAL_PRICE_CONFIG } from "graphql/queries/config/GetExternalPriceProvider"

import { Name } from "components/Ui/Table/Shared.styled"

import { Url } from "./ExternalPriceConfigTableRow.styled"
import { BlurRow } from "components/Ui/Table/TableBlurLoading"
import TableRow from "components/Ui/Table/TableRow"

import { ReactComponent as ExternalPriceLogo } from "images/icons/circle-dollar.svg"

export const getLoadingRow = () => (
  <>
    <ExternalPriceLogo />
    <div>
      <Name>external-price-config-id</Name>
    </div>
    <Url className="hideOnSmallScreens">
      <p>https://baseurl.se</p>
    </Url>
    <Url className="hideOnSmallScreens">
      <p>https://authurl.se</p>
    </Url>
    <div className="hideOnSmallScreens">
      <p>2000-00-00</p>
    </div>
    <div className="hideOnSmallScreens">
      <p>2000-00-00</p>
    </div>
  </>
)

type Props = {
  id: string
  setExternalPriceConfigId?: Dispatch<SetStateAction<string>>
}

export const ExternalPriceConfigTableRow = ({ id, setExternalPriceConfigId }: Props) => {
  const dispatch = useAppDispatch()

  const { data, loading } = useQuery(GET_EXTERNAL_PRICE_CONFIG, {
    variables: { id: id }
  })

  const getExternalPriceConfig = data?.getExternalPriceConfig

  if (loading) return <BlurRow>{getLoadingRow()}</BlurRow>

  return (
    <TableRow
      key={id}
      handleOnClick={() => {
        if (setExternalPriceConfigId) setExternalPriceConfigId(getExternalPriceConfig.id)
        dispatch(showEditSidebar())
      }}
    >
      <ExternalPriceLogo />
      <div>
        <Name>{getExternalPriceConfig?.id}</Name>
      </div>
      <Url className="hideOnSmallScreens">
        <p>{getExternalPriceConfig?.baseUrl}</p>
      </Url>
      <Url className="hideOnSmallScreens">
        <p>{getExternalPriceConfig?.authUrl}</p>
      </Url>
      <div className="hideOnSmallScreens">
        <p>{dayjs(getExternalPriceConfig?.created).format("YYYY-MM-DD")}</p>
      </div>
      <div className="hideOnSmallScreens">
        <p>{dayjs(getExternalPriceConfig?.updated).format("YYYY-MM-DD")}</p>
      </div>
    </TableRow>
  )
}
